export const chat = {
  chat: {
    shape:
      '<path d="M13.875 10.3425C13.875 10.674 13.7433 10.992 13.5089 11.2264C13.2745 11.4608 12.9565 11.5925 12.625 11.5925H5.125L2.625 14.0925V4.09253C2.625 3.76101 2.7567 3.44307 2.99112 3.20865C3.22554 2.97423 3.54348 2.84253 3.875 2.84253H12.625C12.9565 2.84253 13.2745 2.97423 13.5089 3.20865C13.7433 3.44307 13.875 3.76101 13.875 4.09253V10.3425Z" stroke="#333333" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>',
  },
};
